import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import CheckIcon from "@material-ui/icons/CheckCircle";

import RouteConfigHandler from "../../templates/route-config-handler";
import WebPageMainRegion from "../../templates/WebPageMainRegion";
import EmailVerificationForm from "./templates/email-verification-form";
import EmailVerificationIconImg from "../../../images/email_verification_icon.png";

import "./style.css";

const NO_OF_EMAIL_VERIFICATION_BENEFITS = 5;

const AddUserEmailPage = ({ routeId }) => {
  const { t } = useTranslation();
  const digitIterator = Array.from(
    new Array(NO_OF_EMAIL_VERIFICATION_BENEFITS).keys()
  );

  return (
    <RouteConfigHandler id={routeId}>
      <WebPageMainRegion
        showFooter={true}
        pageHeading={t("settingPage.verifyYourEmailAddress")}
      >
        <Grid className="add-user-email-page-content text-font-family-primary">
          <Grid
            item
            className="page-section"
            container
            direction="column"
            alignItems="center"
          >
            <img
              src={EmailVerificationIconImg}
              alt="email-verificaiton"
              className="email-verification-page-img"
            />
            <Grid container direction="column" className="row-gap-8">
              <Typography className="typography-body-1 text-semi-bold">
                {t("settingPage.emailVerificationFeatureListHeading")}
              </Typography>
              <Grid
                container
                direction="column"
                className="feature-list-container"
              >
                {digitIterator.map((item) => (
                  <Typography
                    key={item}
                    className="typography-body-2 feature-item"
                  >
                    <CheckIcon className="check-icon" />
                    {t(`settingPage.emailVerificationFeature${item + 1}`)}
                  </Typography>
                ))}
              </Grid>
              <Typography className="typography-body-2 pt-16 text-bold">
                {t("settingPage.emailVerificationFeatureListEndDescription")}
              </Typography>
            </Grid>
          </Grid>
          <Grid item className="page-section" container alignItems="flex-start">
            <EmailVerificationForm />
          </Grid>
        </Grid>
      </WebPageMainRegion>
    </RouteConfigHandler>
  );
};

export default AddUserEmailPage;
